// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"bonusgame","826":"index"}[chunkId] || chunkId) + "." + {"245":"87289","272":"8a1bb","826":"218f8"}[chunkId] + ".js";
};